// Import external
import { Component, Input } from '@angular/core';

@Component({

    selector: 'syn-language-flag',
    templateUrl: 'language-flag.component.html',
})
export class LanguageFlagComponent {

    @Input()
    public language: string;

    public readonly AVAILABLE_LANGUAGES = [{
        code: 'fr',
        flag: 'fr',
        name: 'french'
    }, {
        code: 'en',
        flag: 'gb',
        name: 'english'
    }];
}
